<template>
 <router-view></router-view>

</template>

<script>

export default {
  name: 'App',
  components: {
  }
}
</script>

<style>
/* ============================================
   Fix Modal Z-Index Global
   Override supaya modal selalu di atas backdrop
   dan tidak tertutup sidebar/header Velzon
   ============================================ */
.modal-backdrop {
  z-index: 1050 !important;
}

.modal {
  z-index: 1055 !important;
}

.modal-dialog {
  z-index: 1056 !important;
  position: relative;
}
</style>